<template>
  <div class="layout layout-column">
    <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
      <lx-btn :disabled="isDisabled"
              icon="add_circle"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :tooltip="$t('FORMS_DIVERSE.MODULE_SURGEON_ADD')"
              :label="$t('FORMS_DIVERSE.MODULE_SURGEON_ADD')"
              iconSize="21"
              :width="'auto'"
              :height="35"
              classes="text-none"
              @click="addItem(path, {})"
      ></lx-btn>
    </div>

    <v-divider v-bind:style="{'border-color':compColor.lightDivider}" v-if="model && model.length > 0"></v-divider>

    <div :key="index" v-for="(item, index) in model"
         class="layout-row pa-0 ma-2"
         :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
         style="border-radius:4px;"
         :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

      <div class="layout-row layout-wrap flex px-3">
        <div class="flex-gt-sm-50 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.nachname'"
                               :ref="path + '.' + index + '.nachname'"
                               rules="required|name_string"
                               v-slot="{ errors }">
            <long-input
              :color="compColor.primeColor"
              :name="path + '.' + index + '.nachname'"
              label="Nachname *"
              v-model="item.nachname"
              :disabled="isDisabled"
              class="mb-0"
              :dense="denseFields"
              :hide-details="!errors || errors.length <= 0"
              :error="errors[0]"
            ></long-input>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-50 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.vornamen'"
                               :ref="path + '.' + index + '.vornamen'"
                               rules="required|name_string"
                               v-slot="{ errors }">
            <long-input
              :color="compColor.primeColor"
              :name="path + '.' + index + '.vornamen'"
              label="Vornamen *"
              v-model="item.vornamen"
              :disabled="isDisabled"
              class="mb-0"
              :dense="denseFields"
              hint="Bei mehreren Vornamen können diese durch Leerzeichen getrennt übermittelt werden."
              :persistent_hint="true"
              :error="errors[0]"
            ></long-input>
          </validation-provider>
        </div>

        <div class="flex-100 px-2 pb-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.hauptoperateur'"
                               :ref="path + '.' + index + '.hauptoperateur'"
                               :rules="{required: true}"
                               class="layout-column"
                               v-slot="{ errors }">
            <fake-input-frame label="Hauptoperateur? *"
                              :disabled="isDisabled"
                              :errors="errors.length > 0">

              <div class="px-4 pb-3 pt-1 flex">
                <v-radio-group :dense="denseFields" v-model="item.hauptoperateur" row hide-details :error-messages="errors[0]" class="ma-0 pa-0">
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES')"
                           value="J" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO')"
                           value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.UNKNOWN')"
                           value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                </v-radio-group>
              </div>
            </fake-input-frame>

            <!-- Anzeige Fehlermeldung  -->
            <span class="error--text" style="line-height:12px;font-size:12px;margin-top: 3px;margin-left:6px;">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>

      <div class="layout-column layout-align-center-center px-3"
           :class="{'grey lighten-2': !compColor.isInDarkMode}"
           :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
        <lx-btn @click="deleteSurgeon(path, index, path + '.' + index + '.nachname')"
                :color="compColor.primeColor"
                :iconColor="'white'"
                iconSize="21"
                :width="35"
                :height="35"
                :disabled="isDisabled"
                icon="delete_forever"></lx-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Operateure",
  props: {
    value: {
      type: Array,
      default: () => ([{}])
    },
    path: {
      type: String
    },
    addItem: {
      type: Function
    },
    deleteItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    disableManuallyValidate: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: []
    }
  },
  methods: {
    /**
     * Delete selected element of surgeons and trigger validator for saving
     */
    deleteSurgeon (path, index, field) {
      this.deleteItem(path, index)

      // trigger validator only in documentation and not in import
      if(!this.disableManuallyValidate) {
        this.validationRef.fields[field].changed = true
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
